module.exports = __webpack_public_path__ + "public/images/slider/davidkina.32ab75a02d961866f81bd59d1d0b027e.png";